<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="agpr-contentSharing" (keydown.escape)="escapeMenu()">
    <button
        class="agpr-contentSharing-button fa-brands fa-x-twitter"
        [id]="id + '.share.twitter'"
        (click)="shareContent(contentSharingTypes.twitter)"
        [hidden]="!content.tweet"
        [agprTooltip]="'Discover.entityProfile.recentCoverage.shareButton.twitter'"
        tooltipPosition="top"
    ></button>
    <button
        class="agpr-contentSharing-button fa-brands fa-facebook"
        [id]="id + '.share.facebook'"
        (click)="shareContent(contentSharingTypes.facebook)"
        [hidden]="!content.facebook"
        [agprTooltip]="'Discover.entityProfile.recentCoverage.shareButton.facebook'"
        tooltipPosition="top"
    ></button>
    <button
        class="agpr-contentSharing-button fa-brands fa-linkedin"
        [id]="id + '.share.linkedin'"
        (click)="shareContent(contentSharingTypes.linkedin)"
        [hidden]="!content.linkedin"
        [agprTooltip]="'Discover.entityProfile.recentCoverage.shareButton.linkedIn'"
        tooltipPosition="top"
    ></button>
    <button
        class="agpr-contentSharing-button fa-regular fa-duotone fa-envelope"
        [id]="id + '.share.email'"
        (click)="shareContent(contentSharingTypes.email)"
        [hidden]="!content.email"
        [agprTooltip]="'Discover.entityProfile.recentCoverage.shareButton.email'"
        tooltipPosition="top"
    ></button>
</div>
